import { APICore } from 'src/helpers/api/apiCore';
import config from 'src/config';
const apiBaseUrl = config.API_URL;
const api = new APICore();

// add Employee
function creatEmployee(params: any) {
    const baseUrl = `/emp/createemp`;
    return api.create(`${baseUrl}`, params);
}
// update Employee
function updateEmployee(params: any) {
    const baseUrl = '/emp/updateemp';
    return api.update(`${baseUrl}`, params);
}

// get all employees
function getAllEmployee(params: any) {
    const baseUrl = '/emp/empList';
    return api.create(`${baseUrl}`, params);
}

// get Employee
function getEmployee(params: any) {
    const baseUrl = '/emp/empDetail';
    return api.create(`${baseUrl}`, params);
}

export { creatEmployee, updateEmployee, getAllEmployee, getEmployee };
